let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("lJGjE")]).then(() => parcelRequire('k0hQy'));